import isEqual from "lodash.isequal";

const reduceParams = (params, filtered=[]) => {
    return Object.keys(params)
        .filter(key => filtered.indexOf(key) === -1)
        .reduce((acc, key) => {
            return {...acc, [key]: params[key]};
        }, {});
}


export const shouldAdsRefresh = (params, prevParams) => {
    if (!params || !prevParams) {
        return false;
    }

    // should ignore changes in map and q
    const keysToFilter = ['neLat', 'neLong', 'swLat', 'swLong', 'zoom', 'q'];

    const reducedParams = reduceParams(params, keysToFilter);
    const reducedPrevParams = reduceParams(prevParams, keysToFilter);

    return !isEqual(reducedParams, reducedPrevParams);
};
